(() => {
  const reviewWidgetIds = [
    "feefo-product-review-widgetId",
    "feefo-service-review-widgetId",
  ];
  const compactStyleId = "ds-feefo-compact-styles";
  const observedRoots = new WeakSet();

  const compactCss = `
    [data-ds-hidden-review-action],
    [data-ds-review-actions-row] { display: none !important; }

    [data-ds-review-card] {
      gap: 24px !important;
      padding-bottom: 14px !important;
    }
    [data-ds-review-layout] { gap: 20px !important; }
    [data-ds-review-footer] {
      gap: 0 !important;
      min-height: 0 !important;
    }

    [data-ds-award-card] {
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      height: auto !important;
      min-height: 0 !important;
      padding: 14px !important;
      gap: 16px !important;
    }
    [data-ds-award-visual] {
      flex: 0 0 140px !important;
      width: 140px !important;
      height: 140px !important;
      min-height: 140px !important;
      overflow: visible !important;
    }
    [data-ds-award-image] {
      display: block !important;
      width: 140px !important;
      height: 140px !important;
      max-width: none !important;
      object-fit: contain !important;
    }
    [data-ds-award-visual] > div { display: none !important; }
    [data-ds-award-link] {
      flex: 1 1 auto !important;
      min-width: 0 !important;
      font-size: 14px !important;
      line-height: 1.35 !important;
    }

    @media (max-width: 749px) {
      [data-ds-review-card] { gap: 18px !important; padding-bottom: 10px !important; }
      [data-ds-review-layout] { gap: 16px !important; }
      [data-ds-award-card] { padding: 12px !important; gap: 12px !important; }
      [data-ds-award-visual] {
        flex-basis: 120px !important;
        width: 120px !important;
        height: 120px !important;
        min-height: 120px !important;
      }
      [data-ds-award-image] { width: 120px !important; height: 120px !important; }
    }
  `;

  const markCompactElements = (root) => {
    if (!root.getElementById(compactStyleId)) {
      const style = document.createElement("style");
      style.id = compactStyleId;
      style.textContent = compactCss;
      root.append(style);
    }

    root.querySelectorAll("button, [role='combobox']").forEach((control) => {
      const text = (control.textContent || "").trim();
      const label = control.getAttribute("aria-label") || "";
      if (text !== "Share" && !/^Review actions$/i.test(label)) return;

      control.setAttribute("data-ds-hidden-review-action", "");

      const actionsRow = control.parentElement;
      const footer = actionsRow?.parentElement;
      const body = footer?.parentElement;
      const layout = body?.parentElement;
      const card = layout?.parentElement;

      actionsRow?.setAttribute("data-ds-review-actions-row", "");
      footer?.setAttribute("data-ds-review-footer", "");
      layout?.setAttribute("data-ds-review-layout", "");
      card?.setAttribute("data-ds-review-card", "");
    });

    const awardLink = [...root.querySelectorAll("a")].find((link) =>
      /Trusted Service Awards/i.test(link.textContent || "")
    );
    const awardCard = awardLink?.closest(".widgets-card") || awardLink?.parentElement;

    if (awardCard) {
      awardCard.setAttribute("data-ds-award-card", "");
      awardLink.setAttribute("data-ds-award-link", "");
      awardCard.firstElementChild?.setAttribute("data-ds-award-visual", "");
      awardCard.querySelector("img")?.setAttribute("data-ds-award-image", "");
    }
  };

  const enhanceReviewWidgets = () => {
    let widgetFound = false;

    reviewWidgetIds.forEach((widgetId) => {
      const widget = document.querySelector(`#${widgetId} > div`);
      const root = widget?.shadowRoot;
      if (!root) return;

      widgetFound = true;
      markCompactElements(root);

      if (!observedRoots.has(root)) {
        new MutationObserver(() => markCompactElements(root)).observe(root, {
          childList: true,
          subtree: true,
        });
        observedRoots.add(root);
      }
    });

    return widgetFound;
  };

  const widgetObserver = new MutationObserver(() => {
    if (enhanceReviewWidgets()) widgetObserver.disconnect();
  });

  if (!enhanceReviewWidgets()) {
    widgetObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;

    const rating = event.target.closest(".pdp-v2__rating");
    if (!rating) return;

    const reviews = reviewWidgetIds
      .map((widgetId) => document.getElementById(widgetId))
      .find(Boolean);
    if (!reviews) return;

    event.preventDefault();
    reviews.scrollIntoView({ behavior: "smooth", block: "start" });
  });
})();